import { ReactNode, useState } from "react";
import { Sidebar } from "./Sidebar";
import { MobileNav } from "./MobileNav";

interface AppLayoutProps {
  children: ReactNode;
}

export function AppLayout({ children }: AppLayoutProps) {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  return (
    <div className="flex min-h-screen min-h-dvh w-full bg-background">
      <Sidebar mobileOpen={mobileMenuOpen} onMobileClose={() => setMobileMenuOpen(false)} />
      <main 
        className="flex-1 min-w-0 md:ml-64 overflow-y-auto overflow-x-hidden"
        style={{ 
          paddingBottom: 'var(--app-footer-reserve, 5rem)'
        }}
      >
        {children}
      </main>
      <MobileNav />
    </div>
  );
}
